import { create } from "zustand";
import Router from "../views";

export const useUserStore = create((set) => ({
  userInfo: null,

  setUserInfo: (user) => set({ userInfo: user }),

  loadUserInfo: async () => {
    try {
      const data = await Router.Api.fetchUserInfo();
      if (data) {
        set({ userInfo: data });
        return data;
      }
      return null;
    } catch (err) {
      return null;
    }
  },

  clearUserInfo: () => set({ userInfo: null }),
}));
